// extracted by mini-css-extract-plugin
export var cta = "styles-module--cta--yK04M";
export var ctaBordered = "styles-module--ctaBordered--b3NyJ";
export var ctaUnderline = "styles-module--ctaUnderline--aF16+";
export var ctaWhite = "styles-module--ctaWhite--ewc8z";